// extracted by mini-css-extract-plugin
export default {"group":"DashboardCardGroup_group__LFyLE"};